import React from 'react';
import { ResidentialGlass } from './pages/ResidentialGlass/ResidentialGlass';
export function App() {
  return <ResidentialGlass data-id="element-0" />;
}